import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  padding-top: 60px;
  background: linear-gradient(
    180deg,
    rgba(192, 192, 192, 0.85) 10.86%,
    rgba(72, 181, 181, 0.13) 78.74%,
    rgba(255, 255, 255, 0) 100%,
    rgba(255, 255, 255, 0.12) 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 1600px) {
    padding-inline: 70px;
  }
  @media (max-width: 280px) {
    padding-inline: 0;
  }

  > div {
    letter-spacing: -2px;
    color: ${(props) => props.theme.color.active};
    font-weight: 700;
    font-size: 68px;
    font-family: "Noto Sans KR";

    .text {
      display: inline-block;

      &-animation {
        animation: 1s ease 0s normal forwards 1 fadeIn;
      }

      &-animation1 {
        animation: 2.5s ease 0s normal forwards 1 fadeIn;
        display: inline-flex;
      }
    }

    span {
      color: ${(props) => props.theme.color.default};
      /* animation: 2.8s ease 0s normal forwards 1 fadeIn; */
    }

    @media (max-width: 1024px) {
      > .text-animation,
      span {
        display: block;
        text-align: center;
        margin-bottom: 25px;
      }
      > .text-animation1 {
        text-align: center;
        display: block;
        .text-modified {
          display: flex;
          align-items: center;
        }
        span {
          margin-top: 20px;
        }
      }
    }

    @media (max-width: 540px) {
      > .text,
      span {
        letter-spacing: -2px;
        font-size: 52px;
      }
    }
    @media (max-width: 475px) {
      > .text,
      span {
        font-size: 42px;
      }
    }

    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      66% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
  }
`;
